import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgBookinline = function SvgBookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.497 41.54c.28-.007.59.045.929.173 0 0-.42-3.382 2.595-2.98L30.55 23.258a6.584 6.584 0 0 0 .131 9.117l7.083 7.166c1.25 1.264 2.952 2.034 4.733 1.999Z",
    fill: "#D6CF8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.733 46.135V43.15l-2.82 2.82 2.82.164Z",
    fill: "#00B0B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.327 46.013a4.397 4.397 0 0 0 1.812.284l3.697.025a.202.202 0 0 0 .202-.201l-.025-3.698a4.413 4.413 0 0 0-1.285-3.354L30.733 23.075 25.206 28.6a.66.66 0 0 1-.932 0 .636.636 0 0 1 0-.9l5.232-5.233a.6.6 0 0 0 0-.845.6.6 0 0 0-.845 0l-5.686 5.682-.995-.994a4.147 4.147 0 0 1 0-5.863l.076-.076a4.147 4.147 0 0 1 5.863 0",
    stroke: "#001E62",
    strokeWidth: 0.693,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.936 39.277a2.169 2.169 0 0 0-3.07 0 2.174 2.174 0 0 0-.44 2.436 2.174 2.174 0 0 0-2.437.44 2.169 2.169 0 0 0 0 3.07L25.845 30.074M44.469 45.972l3.108-3.112M42.542 38.608 29.964 26.027M40.05 40.483l-12.273-12.27",
    stroke: "#001E62",
    strokeWidth: 0.693,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.982 46.235h3.053c.738 0 1.334.596 1.334 1.334v.07c0 .738-.596 1.334-1.334 1.334h-4.148c-.738 0-1.334.596-1.334 1.334 0 .738.596 1.334 1.334 1.334h10.447c.998 0 1.806-.807 1.806-1.805V16.225H30.508a.545.545 0 0 1-.544-.545v-.408a1.227 1.227 0 1 1 2.453 0v1.736c0 .675.548 1.226 1.227 1.226h.215c.717 0 1.295-.582 1.295-1.296v-1.604c0-.731.593-1.327 1.328-1.327h.062c.731 0 1.327.592 1.327 1.327v1.6a1.296 1.296 0 0 0 2.592 0v-1.6a1.327 1.327 0 0 1 2.654 0v1.6c0 .718.582 1.297 1.296 1.297h.139c.717 0 1.296-.582 1.296-1.296v-1.601a1.327 1.327 0 0 1 2.654 0v1.6a1.296 1.296 0 0 0 2.592 0v-1.6a1.327 1.327 0 0 1 2.654 0v1.6c0 .718.582 1.297 1.296 1.297h.139c.717 0 1.295-.582 1.295-1.296v-1.601c0-.731.593-1.327 1.328-1.327h.18",
    stroke: "#001E62",
    strokeWidth: 0.693,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.035 27.177H38.659M56.035 31.81H44.684M56.035 36.509H47.77M47.313 23.154v10.78M51.95 24.083v16.4M42.75 23.154v6.92M38.228 23.154v4.023M34.402 22.451l21.057.08c.659 0 1.189.537 1.189 1.192V39.54c0 .52-.42.939-.939.939h-1.68",
    stroke: "#00B0B9",
    strokeWidth: 0.693,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.133,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#E6F9FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.32 21.133h-2.096v-9.824H12.32V9.293h4v11.84Z",
    fill: "#2F7B84"
  })));
};
var BookIcon = SvgBookinline;

export { BookIcon as default };
//# sourceMappingURL=book.inline.svg.js.map
